import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { store } from './store/store';
import App from './App';
import './index.css';
import { getInitialTheme, applyTheme } from './components/ui/ThemeToggle';

// Apply persisted theme before first paint to avoid a flash
applyTheme(getInitialTheme());

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: 'var(--card)',
            color: 'var(--g50)',
            border: '1px solid var(--g700)',
            boxShadow: '0 4px 16px rgba(24,26,32,0.08)',
            fontFamily: '"Inter", sans-serif',
          },
          success: { iconTheme: { primary: '#86C442', secondary: '#000' } },
          error: { iconTheme: { primary: '#ef4444', secondary: '#000' } },
        }}
      />
    </BrowserRouter>
  </Provider>
);
